import { render, staticRenderFns } from "./BaseValidationError.vue?vue&type=template&id=475024ba&"
import script from "./BaseValidationError.vue?vue&type=script&lang=js&"
export * from "./BaseValidationError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports